

import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { listadoLotesXStock } from "../../../services";




export const useListLotesXStock = (id) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const page = parseInt(searchParams.get('page') || '0');

    const { data, isLoading } = useQuery({
        queryKey: ['lotesXstock', { page, id }], 
        queryFn: () => listadoLotesXStock({ page, id }),
        enabled: !!id
    });

    const chagePage = useCallback((num) => {
        setSearchParams(prev => {
            prev.set('page', (num - 1).toString());
            return prev;
        }, { replace: true });
    }, [setSearchParams]);

    return {
        // Estados
        page,
        // Métodos
        chagePage,
        data, isLoading,
    }
}

